import React from 'react'
import { Head } from '../../components/Head'
import { SnackTitle } from '../../components/SnackTitle'
import { Snacks } from '../../components/Snacks'
import { useSnack } from '../../hooks/useSnack'

export default function DrinkPage() {
  const { drinks } = useSnack()
  return (
    <>
      <Head title='Hambúrggers' description='Nossos melhores burggers' />
      <SnackTitle>Drinks</SnackTitle>
      {drinks.length > 0 && <Snacks snacks={drinks} />}
    </>
  )
}
